import React from 'react';
import LabOrderItem from './LabOrderItem/LabOrderItem';

const LabOrdersList = (props) => {
    const {orders} = props;
    return(
        <div className="lab-orders-list">
            {
                orders.map((order,index) => {
                    return (
                        <LabOrderItem key={index} order={order} />
                    )
                })
            }
        </div>
    )
}

export default LabOrdersList;